var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatDishwasher = function SvgFeatDishwasher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    viewBox: "0 0 14.2 15.2",
    width: 14.2,
    height: 15.2,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2575"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2573"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    d: "m 6.02,2.43 h 2.17 v 1 H 6.02 Z m -3.5,0 h 2.17 v 1 H 2.52 Z m 9.17,0 H 9.52 v 1 h 2.17 z",
    id: "path2577",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 2.52,5.85 c 0,-0.28 0.22,-0.5 0.5,-0.5 h 3.5 c 0.28,0 0.5,0.22 0.5,0.5 v 2.33 c 0,1.05 -0.73,1.96 -1.75,2.19 v 1.39 h 1.25 v 1 h -3.5 v -1 H 4.27 V 10.37 C 3.25,10.14 2.52,9.23 2.52,8.18 Z m 1,0.5 v 1.83 c 0,0.69 0.56,1.25 1.25,1.25 0.69,0 1.25,-0.56 1.25,-1.25 V 6.35 Z m 4.83,6.5 h 1 v -0.67 h 0.08 c 1.24,0 2.25,-1.01 2.25,-2.25 V 8.18 C 11.68,6.94 10.67,5.93 9.43,5.93 H 9.35 V 5.26 h -1 v 7.58 z m 1,-5.92 v 4.25 h 0.08 c 0.69,0 1.25,-0.56 1.25,-1.25 V 8.18 c 0,-0.69 -0.56,-1.25 -1.25,-1.25 z",
    id: "path2579",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 1.38,0.1 C 0.67,0.1 0.1,0.67 0.1,1.38 v 0 12.44 c 0,0.71 0.57,1.28 1.28,1.28 h 11.44 c 0.71,0 1.28,-0.57 1.28,-1.28 V 1.38 C 14.1,0.67 13.53,0.1 12.82,0.1 Z M 1.1,1.38 C 1.1,1.23 1.22,1.1 1.38,1.1 h 11.44 c 0.15,0 0.28,0.12 0.28,0.28 v 12.44 c 0,0.15 -0.12,0.28 -0.28,0.28 H 1.38 C 1.23,14.1 1.1,13.98 1.1,13.82 Z",
    id: "path2581",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgFeatDishwasher;